import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Card, Row, Col, Collapse, Form, Button, Select, Space, Table, message, Typography } from "antd";
import { SnippetsFilled, EditFilled, PlusSquareOutlined, MinusSquareOutlined } from "@ant-design/icons";
import NumberFormat from "react-number-format";
import dayjs from "dayjs";
import { DebtService } from "./services/debt-service";
import { IuserProfile } from "../datamanagement/models/models-datamanagement";
import { useId24 } from "../../drivers/id24/Id24-provider";
import { loadAppConfig } from "../../config/app-config";
const appConfig = loadAppConfig();
import "moment/locale/th";
import { TablePaginationConfig } from "antd/es/table";
import { DatamanagementService } from "../datamanagement/services/datamanagement-service";
import { BuddhistRangePickerDates, BuddistDateRangePicker } from "../../utils/buddhist-data";

const { Option } = Select;

export interface Props {
  baseURL: string;
  caption: string;
  value: number;
  loading: boolean;
  accessRole: string;
}

export interface IFilterSearch {
  worklist: string[];
  floodStatus: string[];
  riskScore: string[];
  billCode: string[];
  custType: string[];
  lastTermCode: string[];
  bankUsers: string[];
}

export interface IOnSearchFilter {
  worklist?: string[];
  floodStatus?: string[];
  riskScore?: string[];
  billCode?: string[];
  custType?: string[];
  lastTermCode?: string[];
  listName?: string;
}

export interface IDataSource {
  data: any;
  total: number;
}

export const DebtSearch: React.FC<Props> = ({ baseURL, accessRole }): React.ReactElement => {
  const location = useLocation();
  const all: any = location?.state;

  const LIST_TEAM: any = all?.teamId === null ? undefined : all?.teamId;
  const LIST_USER: any = all?.oaName === null ? undefined : all?.oaName;
  const [form] = Form.useForm();
  const { id24Axios } = useId24();
  // const apiBaseUrl = id24Axios(appConfig.apiBaseUrl);
  const apiBaseUrlDebt = id24Axios(appConfig.apiBaseUrlDebt);
  const apiBaseUrlUser = id24Axios(appConfig.apiBaseUrlUser);
  const debtService = DebtService;
  const { push } = useHistory();
  const { Panel } = Collapse;
  const [listName, setListName] = useState<object[]>([]);
  const [loading, setLoading] = useState(true);
  const [exportLoading, setExportLoading] = useState(false);
  const [dataSource, setDataSource] = useState<IDataSource>();
  const [panelShow, setPanelShow] = useState(true);
  const [panelAction, setPanelAction] = useState("1");
  const [filterSearch, setFilterSearch] = useState<IFilterSearch>();
  const [onSearchFilter, setOnSearchFilter] = useState<IOnSearchFilter>({});
  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
  });
  const [userProfile, setUserprofile] = useState<IuserProfile>({
    id: 0,
    level: "",
    name: "",
    oaCode: "",
    parentId: "",
    team: "",
    token: "",
    type: "",
    capabilities: {},
  });
  const [filterListName, setFilterListName] = useState<string>(LIST_TEAM);
  const [bankUserList, setBankUserList] = useState<string>(LIST_USER);
  const getUserProfile = async () => {
    return new Promise<IuserProfile>(async (resolve, reject) => {
      const resultProfile = await DebtService(apiBaseUrlDebt).getUserDetail();
      resolve(resultProfile);
    });
  };

  const getDataTable = async () => {
    const pageSize = pagination.pageSize || 10;
    const current = pagination.current || 1;
    const skip = (current - 1) * pageSize;
    let condition = {} as any;
    condition = {
      skip: skip,
      take: pageSize,
      ...onSearchFilter,
    };
    try {
      const count = await debtService(apiBaseUrlDebt).getCountDebt(condition);
      const countData = Number(count.result[0].count) || 0;
      const res = await debtService(apiBaseUrlDebt).getDebtList(condition);
      const data = (await res.result.map((x: any, index: number) => {
        const mapData = {
          key: index + 1 + skip,
          assignDate: x.assign != null ? dateStamp(x.assign) : "-",
          ...x,
        };
        return mapData;
      })) as any;
      setDataSource({
        data: data,
        total: countData,
      });
    } catch (err) {
      setDataSource({
        data: [],
        total: 0,
      });
      message.error("ไม่พบข้อมูล");
    }
    setLoading(false);
  };

  useEffect(() => {
    getUserProfile().then(async (data) => {
      if (data) {
        setUserprofile(data);
        const resultList = await DebtService(apiBaseUrlDebt).getlistnameBytoken();
        setListName(resultList?.result);
      }
    });
    const loaddatadropdown = async () => {
      const worklist: string[] = await DatamanagementService(apiBaseUrlDebt).getdataworklist();
      const floodStatus: string[] = await DatamanagementService(apiBaseUrlDebt).getdatafloodstatus();
      const riskScore: string[] = await DatamanagementService(apiBaseUrlDebt).getdatariskscore();
      const billCode: string[] = await DatamanagementService(apiBaseUrlDebt).getdatabillcode();
      const custType: string[] = await DatamanagementService(apiBaseUrlDebt).getdatacusttype();
      const lastTermCode: string[] = await DatamanagementService(apiBaseUrlDebt).getdatalasttermcode();
      const bankUsers: string[] = await DatamanagementService(apiBaseUrlUser).getUserBankByOrganize();

      setFilterSearch({
        worklist,
        floodStatus,
        riskScore,
        billCode,
        custType,
        lastTermCode,
        bankUsers,
      });
    };
    loaddatadropdown();
  }, []);

  useEffect(() => {
    getDataTable();
  }, [loading]);

  const onSearch = () => {
    form.validateFields().then((filter) => {
      setOnSearchFilter({
        ...filter,
        dates: filter.dates ? [dayjs(filter.dates[0]).format("YYYY-MM-DD"), dayjs(filter.dates[1]).format("YYYY-MM-DD")] : undefined,
      });
      setPagination((prev) => ({ ...prev, current: 1 }));
      setLoading(true);
    });
  };

  useEffect(() => {
    if (all) {
      if (filterListName !== "") {
        form.setFieldsValue({
          listName: filterListName,
        });
        if (bankUserList !== "") {
          form.setFieldsValue({
            userIdList: bankUserList,
          });
        }
        onSearch();
      }
    }
  }, []);

  const dateStamp = (stamp: any) => {
    const stamptime = new Intl.DateTimeFormat("en-US").format(stamp);
    if (stamptime != null && stamptime != "-" && stamptime != "") {
      return dayjs(stamptime).locale("th").add(543, "year").format("DD-MM-YYYY");
    } else {
      return "";
    }
  };

  const exportCSV = async () => {
    if (dataSource?.total === 0) {
      message.warning(`ไม่พบข้อมูล`);
      return false;
    }

    setExportLoading(true);
    const condition = {
      ...onSearchFilter,
    };
    const res = await debtService(apiBaseUrlDebt).debtSearchExport(condition);
    if (res) {
      message.success("ดำเนินการ Export สำเร็จ");
      setExportLoading(false);
      return;
    }
    message.error("Export Failed!");
    setExportLoading(false);
  };

  const genExtra = () => (
    <>
      {panelShow === false ? (
        <PlusSquareOutlined
          style={{
            color: "#1890FF",
            fontSize: "150%",
            backgroundColor: "#E6F7FF",
          }}
          onClick={() => {
            setPanelShow(true);
            setPanelAction("1");
          }}
        />
      ) : (
        <MinusSquareOutlined
          style={{
            color: "#1890FF",
            fontSize: "150%",
            backgroundColor: "#E6F7FF",
          }}
          onClick={() => {
            setPanelShow(false);
            setPanelAction("0");
          }}
        />
      )}
    </>
  );

  const checkAccessRole = (role: string) => {
    var result = accessRole.indexOf(role) > -1;
    if (result == true) {
      return true;
    } else {
      return false;
    }
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
    },

    {
      title: "วันที่ได้รับงาน",
      dataIndex: "assignDate",
      key: "assignDate",
    },
    {
      title: "CIF",
      dataIndex: "cif",
      key: "cif",
    },
    {
      title: "Account No.",
      dataIndex: "account_no",
      key: "account_no",
      render: (text: string, record: any, index: number) => (text ? <Typography key={index}>{text}</Typography> : <></>),
    },

    {
      title: "ชื่อลูกหนี้",
      dataIndex: "custname",
      key: "custname",
    },
    {
      title: "จำนวนเงินค้างชำระ",
      dataIndex: "osbal",
      key: "osbal",
      align: "right" as const,
      render: (text: string) => (
        <NumberFormat value={text} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={""} />
      ),
    },
    {
      title: "Worklist",
      dataIndex: "worklist",
      key: "worklist",
      render: (text: string) => (text ? text : "-"),
    },
    {
      title: "สีน้ำท่วม",
      dataIndex: "floodstatus",
      key: "floodstatus",
      render: (text: string) => (text ? text : "-"),
    },
    {
      title: "Bscore",
      dataIndex: "riskscore",
      key: "riskscore",
      render: (text: string) => (text ? text : "-"),
    },
    {
      title: "Billcode",
      dataIndex: "billcode",
      key: "billcode",
      render: (text: string) => (text ? text : "-"),
    },
    {
      title: "ประเภทลูกค้า",
      dataIndex: "custtype",
      key: "custtype",
      render: (text: string) => (text ? text : "-"),
    },
    {
      title: "Last Result",
      dataIndex: "lasttermcode",
      key: "lasttermcode",
      render: (text: string) => (text ? text : "-"),
    },
  ];

  return (
    <>
      <Row
        gutter={[
          { xs: 8, sm: 16 },
          { xs: 8, sm: 16 },
        ]}
      >
        <Card style={{ width: "100%", textAlign: "left" }}>
          <b style={{ color: "#0056B4", fontSize: "24px" }}>
            <SnippetsFilled /> DEBT SEARCH
          </b>
        </Card>
      </Row>
      <Row
        style={{ marginTop: "2rem" }}
        gutter={[
          { xs: 8, sm: 16 },
          { xs: 8, sm: 16 },
        ]}
      >
        <Collapse expandIconPosition="right" style={{ width: "100%" }} collapsible={"header"} activeKey={[panelAction]}>
          <Panel
            forceRender={true}
            extra={genExtra()}
            showArrow={false}
            header="เงื่อนไขกำหนดการค้นหาข้อมูล"
            key="1"
            style={{ backgroundColor: "white" }}
          >
            <Form form={form} layout="vertical" onFinish={onSearch}>
              <Row>
                <Col span={6} style={{ paddingRight: "10px" }}>
                  <BuddhistRangePickerDates />
                </Col>
                <Col span={6} style={{ paddingRight: "10px" }}>
                  <Form.Item label="Worklist" name={`workList`}>
                    <Select
                      showArrow
                      mode="multiple"
                      style={{ width: "100%" }}
                      placeholder={`Please Select`}
                      options={filterSearch?.worklist?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ paddingRight: "10px" }}>
                  <Form.Item label="สีน้ำท่วม" name={`floodStatus`}>
                    <Select
                      showArrow
                      mode="multiple"
                      style={{ width: "100%" }}
                      placeholder={`Please Select`}
                      options={filterSearch?.floodStatus?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ paddingRight: "10px" }}>
                  <Form.Item label="Bscore" name={`riskScore`}>
                    <Select
                      showArrow
                      style={{ width: "100%" }}
                      mode="multiple"
                      placeholder={`Please Select`}
                      options={filterSearch?.riskScore?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ paddingRight: "10px" }}>
                  <Form.Item label="Billcode" name={`billCode`}>
                    <Select
                      showArrow
                      style={{ width: "100%" }}
                      mode="multiple"
                      placeholder={`Please Select`}
                      options={filterSearch?.billCode?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ paddingRight: "10px" }}>
                  <Form.Item label="ประเภทลูกค้า" name={`custType`}>
                    <Select
                      showArrow
                      style={{ width: "100%" }}
                      mode="multiple"
                      placeholder={`Please Select`}
                      options={filterSearch?.custType?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ paddingRight: "10px" }}>
                  <Form.Item label="Last Result" name={`lastTermCode`}>
                    <Select
                      showArrow
                      style={{ width: "100%" }}
                      placeholder={`Please Select`}
                      mode="multiple"
                      options={filterSearch?.lastTermCode?.map((value: string, index: number) => ({ label: value, value: value, key: index }))}
                    />
                  </Form.Item>
                </Col>
                {checkAccessRole("ddebtDebtManagementListfield") && (
                  <Col span={6} style={{ paddingRight: "10px" }}>
                    <Form.Item label="List" name="listName">
                      <Select
                        showArrow
                        allowClear
                        placeholder="Please Select"
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input: any, option: any) => option.children.toString().toLowerCase().includes(input.toLowerCase())}
                        onChange={(e: any) => {
                          setFilterListName(e);
                        }}
                      >
                        {userProfile.level === "ADMIN" ? (
                          <>
                            <Option key={`unassigned`} value={`unassigned`}>
                              {`Unassigned`}
                            </Option>
                          </>
                        ) : (
                          <></>
                        )}
                        {listName?.map((opt: any, num: any) => {
                          return (
                            <Option key={opt.list_name_seq} value={opt.list_name_real}>
                              {opt.list_name_real}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                )}
                {checkAccessRole("ddebtDebtManagementUserfield") && (
                  <Col span={6} style={{ paddingRight: "10px" }}>
                    <Form.Item label="User" name="userIdList">
                      <Select
                        showArrow
                        allowClear
                        placeholder="Please Select"
                        showSearch
                        optionFilterProp="label"
                        style={{ width: "100%" }}
                        onChange={(e: any) => {
                          setBankUserList(e);
                        }}
                        options={filterSearch?.bankUsers?.map((value: any, index: number) => ({
                          label: value?.username,
                          value: value?.username,
                          key: index,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
              <Row>
                <Col span={24} style={{ textAlign: "right", paddingRight: "10px" }}>
                  <Form.Item>
                    <Space>
                      <Button type="primary" htmlType="submit">
                        Search
                      </Button>
                      <>
                        {checkAccessRole("ddebtDebtManagementDebtExport") ? (
                          <Button type="primary" onClick={exportCSV} danger loading={exportLoading}>
                            Export
                          </Button>
                        ) : (
                          ""
                        )}
                      </>
                    </Space>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Panel>
        </Collapse>
      </Row>
      <Row
        gutter={[
          { xs: 8, sm: 16 },
          { xs: 8, sm: 16 },
        ]}
        style={{ marginTop: "2rem" }}
      >
        <Card style={{ width: "100%", textAlign: "left" }}>
          <h1 style={{ display: "inline" }}>แสดงผลการค้นหาข้อมูล</h1>
          <Row>
            <Table
              size="small"
              loading={loading}
              dataSource={dataSource?.data}
              columns={columns}
              scroll={{ x: "calc(900px + 50%)" }}
              rowKey={(record) => record.account_no}
              pagination={{ total: dataSource?.total, current: pagination.current }}
              style={{ width: "100%", marginTop: "10px" }}
              onChange={(paginationConfig: TablePaginationConfig) => {
                setPagination({
                  current: paginationConfig.current,
                  pageSize: paginationConfig.pageSize,
                });
                setLoading(true);
              }}
            />
          </Row>
        </Card>
      </Row>
    </>
  );
};
